import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Contact from "../components/Contact";

const ContactPage = () => {
    return (
        <div className="contact-page-wrapper">
            <Helmet>
                <title>Contact Us | VNM Hitech Solutions</title>
                <meta name="description" content="Get in touch with VNM Hitech Solutions for custom software development, IT services, and technical support in Karur." />
            </Helmet>
            <Header />
            <main style={{ paddingTop: '80px', minHeight: 'calc(100vh - 80px)' }}>
                <Contact />
            </main>
            <Footer />
        </div>
    );
};

export default ContactPage;
